import { GET_CATEGORIES, DELETE_CATEGORY, ACCESS_RIGHT_ERROR, EDIT_CATEGORIES, NEW_CATEGORY, GET_ACCESS_RIGHTS, START_LOADING, STOP_LOADING, ERROR } from "../categoriesAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false,
  message_valid: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_CATEGORIES:
      return {
        ...state,
        categories_list: action.payload,
        loading: false,
        success: false

      }
    case EDIT_CATEGORIES:
      return {
        ...state,
        edited_category: action.payload,
        loading: false
      }
    case NEW_CATEGORY:
      return {
        ...state,
        new_category: action.payload,
        loading: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case GET_ACCESS_RIGHTS:
      return {
        ...state,
        access_rights: action.payload,
        loading: false
      }
    case DELETE_CATEGORY:
      return {
        ...state,
        success: true,
        loading: false
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        message_valid: !state.message_valid,
        loading: false
      }
    case ACCESS_RIGHT_ERROR:
      return {
        ...state,
        access_error: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}